"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = exports.Column = exports.Container = exports.StyledSearchLabel = exports.StyledSearchWrapper = exports.getSearchStyles = void 0;
var styled_components_1 = require("styled-components");
var types_1 = require("../../utils/types");
var theme_1 = require("../../utils/theme");
exports.getSearchStyles = function (theme, disabled) {
    var _a;
    var lightActionStyles = disabled ? {} : {
        ':hover:enabled': {
            backgroundColor: theme_1.colors.green50,
            borderColor: theme_1.colors.grey700
        },
        ':focus:enabled': {
            backgroundColor: theme_1.colors.green50,
            borderColor: theme_1.colors.grey700
        },
        ':active:enabled': {
            backgroundColor: theme_1.colors.green50,
            borderColor: theme_1.colors.grey700
        },
    };
    var darkActionStyles = disabled ? {} : {
        ':hover': {
            svg: {
                fill: theme_1.colors.white
            }
        },
        ':focus': {
            svg: {
                fill: theme_1.colors.white
            }
        },
        ':active': {
            svg: {
                fill: theme_1.colors.white
            }
        },
    };
    var searchStyles = (_a = {},
        _a[types_1.LIGHT] = __assign({ svg: {
                fill: disabled ? theme_1.colors.grey400 : theme_1.colors.grey700,
            } }, lightActionStyles),
        _a[types_1.DARK] = __assign({ svg: {
                fill: disabled ? theme_1.colors.grey500 : theme_1.colors.grey400,
            } }, darkActionStyles),
        _a);
    return searchStyles[theme];
};
exports.StyledSearchWrapper = styled_components_1.default.div({
    display: 'flex',
    height: theme_1.scaffolding.xl,
    position: 'relative',
}, function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return (__assign({}, exports.getSearchStyles(theme, disabled)));
}, function (_a) {
    var small = _a.small;
    return small ? {
        '.ap-simple-search': {
            paddingLeft: '40px'
        },
        '.ap-simple-search-search': {
            left: '8px',
        }
    } : {
        '.ap-simple-search': {
            paddingLeft: '44px'
        },
        '.ap-simple-search-search': {
            left: '12px',
        }
    };
});
exports.StyledSearchLabel = styled_components_1.default.label(__assign(__assign({}, theme_1.font), { alignItems: 'center', display: 'flex', outline: 'none', position: 'relative', width: '100%', 
    /* tslint:disable */
    WebkitTapHighlightColor: theme_1.colors.transparent, '.ap-simple-search-search': {
        position: 'absolute',
    }, '.ap-simple-search-clear': {
        position: 'absolute',
        right: '4px',
    } }));
exports.Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: 16px 80px;\n    display: flex;\n    flexDirection: column;\n"], ["\n    margin: 16px 80px;\n    display: flex;\n    flexDirection: column;\n"])));
exports.Column = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    margin: 24px;\n"], ["\n    display: flex;\n    flex-direction: column;\n    margin: 24px;\n"])));
exports.Title = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-bottom: 12px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid ", ";\n    white-space: nowrap;\n"], ["\n    margin-bottom: 12px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid ", ";\n    white-space: nowrap;\n"])), theme_1.colors.grey400);
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=styles.js.map